import React from "react";

const Alert = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className = '', ...props }, ref) => 
  React.createElement('div', {
    ref,
    role: 'alert',
    className: `relative w-full rounded-lg border p-4 ${className}`,
    ...props
  })
)
Alert.displayName = "Alert"

const AlertDescription = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className = '', ...props }, ref) => 
  React.createElement('div', {
    ref,
    className: `text-sm ${className}`,
    ...props
  })
)
AlertDescription.displayName = "AlertDescription"

export { Alert, AlertDescription }
